import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getUser, updateUser} from "api-v3";
import {queryKeys} from "utils/constants";

export const useGetUser = ci => {
  return useQuery(queryKeys.user(ci), () => getUser(ci).then(response => response.data), {
    enabled: !!ci,
  });
};

// export const useUpdateNickname = ci => {
//   const queryClient = useQueryClient();
//   return useMutation(data => updateUser(data), {
//     onSuccess: () => {
//       queryClient.invalidateQueries(queryKeys.user(ci));
//     },
//   });
// };

// export const useUpdatePhone = ci => {
//   const queryClient = useQueryClient();
//   return useMutation(data => updateUser(data), {
//     onSuccess: () => {
//       queryClient.invalidateQueries(queryKeys.user(ci));
//     },
//   });
// };
